module.exports = __webpack_public_path__ + "img/middle_7.fc437614.png";